module.exports = __webpack_public_path__ + "img/additionalEquipment_150.429e014d.webp";